var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132476",
    "data-name": "Group 132476",
    transform: "translate(-386.714 -442.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g405",
    transform: "translate(386.714 442.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path407",
    d: "M25.645-215.578a.815.815,0,0,1-.578-.24,8.174,8.174,0,0,0-5.817-2.409,8.174,8.174,0,0,0-5.818,2.41.816.816,0,0,1-.577.239.815.815,0,0,1-.578-.24,8.174,8.174,0,0,0-5.817-2.409,8.174,8.174,0,0,0-5.814,2.406.816.816,0,0,1-.581.243.815.815,0,0,1-.815-.815,19.9,19.9,0,0,1,1.522-7.654,19.9,19.9,0,0,1,4.335-6.488,19.9,19.9,0,0,1,6.488-4.335,19.9,19.9,0,0,1,7.653-1.522,19.9,19.9,0,0,1,7.654,1.522,19.9,19.9,0,0,1,6.488,4.335,19.9,19.9,0,0,1,4.335,6.488,19.9,19.9,0,0,1,1.522,7.654.816.816,0,0,1-.513.757.815.815,0,0,1-.881-.182,8.174,8.174,0,0,0-5.817-2.408,8.174,8.174,0,0,0-5.818,2.409A.813.813,0,0,1,25.645-215.578ZM6.46-219.858a9.785,9.785,0,0,1,6.395,2.355,9.785,9.785,0,0,1,6.395-2.355,9.786,9.786,0,0,1,6.395,2.354,9.786,9.786,0,0,1,6.395-2.354,9.789,9.789,0,0,1,5.494,1.669,18.231,18.231,0,0,0-5.294-11.194,18.249,18.249,0,0,0-12.989-5.38,18.249,18.249,0,0,0-12.99,5.38A18.232,18.232,0,0,0,.967-218.189,9.79,9.79,0,0,1,6.46-219.858Z",
    transform: "translate(0.75 236.393)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g409",
    transform: "translate(395.42 459.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path411",
    d: "M-123.235,22.681a6.054,6.054,0,0,1-6.048-6.048.815.815,0,0,1,.815-.815.815.815,0,0,1,.815.815,4.422,4.422,0,0,0,4.417,4.417,4.388,4.388,0,0,0,3.123-1.294,4.388,4.388,0,0,0,1.294-3.123V.065A.815.815,0,0,1-118-.75a.815.815,0,0,1,.815.815V16.634a6.008,6.008,0,0,1-1.771,4.276A6.008,6.008,0,0,1-123.235,22.681Z",
    transform: "translate(129.283 0.75)",
    fill: "#09143a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/Umbrella.45a006e7bdf7b751a6104edd3bf1e7c5.svg";
export { ForwardRef as ReactComponent };